import cn from 'classnames';
import { ComponentCommonTextEditorWithHtml } from '..';

function cleanParagraphBrTags(html: string): string {
  return html
    .replace(new RegExp('&nbsp;', 'g'), ' ')
    .replace(new RegExp('(<p[^>]*>)\\s*(<br\\s*/?>\\s*)+', 'gi'), '$1')
    .replace(new RegExp('(<br\\s*/?>\\s*)+</p>', 'gi'), '</p>');
}

export default function DefaultContentTemplateTextEditor({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonTextEditorWithHtml;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  const markdown = cleanParagraphBrTags(component.markdownText || '');

  return (
    <p
      key={markdown}
      className={cn('arrow-scope quote-scope overflow-auto whitespace-pre-wrap', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}
      dangerouslySetInnerHTML={{
        __html: markdown || '',
      }}
    />
  );
}
